import axios from 'axios';

import { baseUrl } from './env';

export const api = axios.create({
  baseURL: baseUrl,
});
